/** Shared workflow status helpers for dashboard / worklist views */

export function isTodayDate(value) {
  if (!value) return false;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return false;
  const now = new Date();
  return d.toDateString() === now.toDateString();
}

export function studyHasImages(study) {
  return Boolean(
    study?.hasImages || study?.totalInstances > 0 || study?.instanceCount > 0,
  );
}

export function resolveWorkflowStatusLabel(study) {
  if (study?.isPatientOnly) return "Registered";

  const raw = study?.orderStatus || study?.status || "";
  const code = String(raw).toUpperCase();

  switch (code) {
    case "NEW":
    case "READY":
      return "Scheduled";
    case "ARRIVAL":
    case "ARRIVED":
      // Images present mean the technologist has started — bump to Awaiting Report
      return studyHasImages(study) ? "Awaiting Report" : "Arrived";
    case "STARTED":
    case "IN_EXAM":
      return "In Exam Room";
    case "ENDEXAM":
    case "QC":
    case "TOREPORT":
    case "PRELIM":
    case "AWAITING_REPORT":
      return "Awaiting Report";
    case "REPORTED":
      return "Completed";
    case "CANCELLED":
      return "Cancelled";
    default:
      return "Arrived";
  }
}

export const WORKFLOW_STATUS_COLORS = {
  Registered: "#6B7280",
  Scheduled: "#6B7280",
  Arrived: "#10B981",
  "In Exam Room": "#3B82F6",
  "Awaiting Report": "#F59E0B",
  Completed: "#10B981",
  Cancelled: "#EF4444",
};
